// @mui
import IconButton from "@mui/material/IconButton";
// icons
import { LiaBell } from "react-icons/lia";
// hooks
import { useTheme, alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { paths } from "routes/paths";
import { useProfileQuery } from "services";
import { Badge } from "@mui/material";

export const Notifications = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { data } = useProfileQuery(
    {},
    {
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
    }
  );

  function handleNavigateToNotifications() {
    navigate(paths.notifications);
  }

  return (
    <IconButton
      size={"large"}
      onClick={handleNavigateToNotifications}
      sx={{
        width: 40,
        height: 40,
        borderRadius: "12px",
        transition: theme.transitions.create(
          ["background-color", "transform"],
          {
            duration: theme.transitions.duration.shortest,
          }
        ),
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
      }}
    >
      <Badge
        badgeContent={data?.notificationBadgeCount || 0}
        color="error"
        max={99}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          "& .MuiBadge-badge": {
            fontSize: "0.6rem",
            height: 16,
            minWidth: 16,
            fontWeight: 700,
            padding: "0 4px",
            boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
          },
        }}
      >
        <LiaBell
          strokeWidth="0.25px"
          color={theme.palette.text.primary}
          size={21}
        />
      </Badge>
    </IconButton>
  );
};
